import React, { useEffect } from 'react';
import Modal from '../../../../../components/Modal';
import Section from '../../../../../components/outline/Section';
import Tabs from '../../../../../components/Tabs/Tabs';
import { setDiscountTypeContentForm } from '../../../../../lib/utils/couponUtils';
import {
  COUPON_DISCOUNT_TYPE_SELECT_LIST,
  BRAND_DISCOUNT_RATE_TYPE,
} from '../../../../../constants/service/app/couponConstants';
import BrandSettlementSection from './BrandSettlementSection';
import './EditCouponDiscountModal.scss';

const EditCouponDiscountModal = (props) => {
  const {
    form,
    isOpen,
    setData,
    onSubmit,
    closeModal,
    onDiscountTypeChange,
    discountType,
    minimumPurchasePrice,
    discountAmount,
    maxDiscountPrice,
    settlementShare,
    isEditPage,
  } = props;

  // 쿠폰 할인 타입에 따라 브랜드 분담 타입 자동 결정
  const brandDiscountRateType = discountType === 1 ? BRAND_DISCOUNT_RATE_TYPE.RATE : BRAND_DISCOUNT_RATE_TYPE.AMOUNT;

  return (
    <Modal
      title="쿠폰 할인 타입 편집하기"
      isOpen={isOpen}
      width={1200}
      height={400}
      isFooter={true}
      okText="적용하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      {/*쿠폰 할인 타입*/}
      <Section className="edit-coupon-discount-type tap-section" title="쿠폰 할인 타입">
        <Tabs
          tabPosition="left"
          activeKey={discountType}
          onChange={(key) => onDiscountTypeChange(key)}
          list={COUPON_DISCOUNT_TYPE_SELECT_LIST.map((item) => ({
            title: item.name,
            content: setDiscountTypeContentForm(form, setData, true, {
              /**
               *  쿠폰의 할인 타입
               */
              type: item.id,
              /**
               *  현재 쿠폰의 할인 타입
               */
              discountType,
              /**
               *  할인 타입에 따른 혜택 수치
               */
              discountAmount,
              /**
               *  최소 구매 금액
               */
              minimumPurchasePrice,
              /**
               *  최대 할인 가능 금액
               */
              maxDiscountPrice,
              /**
               *  브랜드 분담 설정
               */
              settlementShare,
            }),
          }))}
        />
      </Section>

      {/*브랜드 분담 설정*/}
      <BrandSettlementSection
        form={form}
        brandDiscountRateType={brandDiscountRateType}
        discountType={discountType}
        discountAmount={discountAmount}
        settlementShare={settlementShare}
        setData={setData}
        isEditPage={isEditPage}
      />
    </Modal>
  );
};

export default EditCouponDiscountModal;
